module.exports = __webpack_public_path__ + "static/media/storePurchase_250_500.8d99a081.png";